import { render, staticRenderFns } from "./CyclopediaLocalizationsCard.vue?vue&type=template&id=784872c4&scoped=true&"
import script from "./CyclopediaLocalizationsCard.vue?vue&type=script&lang=js&"
export * from "./CyclopediaLocalizationsCard.vue?vue&type=script&lang=js&"
import style0 from "./CyclopediaLocalizationsCard.vue?vue&type=style&index=0&id=784872c4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784872c4",
  null
  
)

export default component.exports